import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './utils/directives.js'
import '@/assets/icon/iconfont.css'
import '@/assets/icon/iconfont.js'

import i18n from '@/lang'



// 配置ElementUI的中英切换逻辑
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
})

// import Vue from 'vue';
import CryptoJS from 'crypto-js';
const secretKey = 'yuzhouwudidiaozhatian'; // 替换为您自己的密钥
function encryptData(data) {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
  return encryptedData;
}

function decryptData(encryptedData) {
  const decryptedData = CryptoJS.AES.decrypt(encryptedData, secretKey).toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedData);
}
Vue.prototype.$encryptData = encryptData;
Vue.prototype.$decryptData = decryptData;
//全局注册基于Vue的markdown编辑器mavon-editor
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
//使用mavon-editor
Vue.use(mavonEditor)

// 复制功能插件
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
Vue.prototype.axios = axios;
import api from '@/api/api'
Vue.prototype.$api = api;


Vue.config.productionTip = false


Vue.use(ElementUI);
import '@/assets/style/base.css'
import '@/assets/style/common.css'
import $ from 'jquery'

Vue.prototype.$ = $

import MathJax from '@/utils/globalVariable'
Vue.prototype.MathJax = MathJax


// import Vue from 'vue'
import VueTypedJs from 'vue-typed-js'

Vue.use(VueTypedJs)

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css';

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  }
})
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})


new Vue({
  axios,
  i18n,
  router,
  store,
  data: {
    // baseURL: 'http://192.168.66.60:8009', //this.$root.baseURL
    baseURL: window.location.origin,
    // baseURL: 'http://192.168.44.65'
    // baseURL: 'https://chatlibraryin.newacademic.net',
  },
  render: h => h(App)
}).$mount('#app')
